// Util de destino do clique para imagens de componente do storefront.
//
// Contrato esperado da imagem (vem do componente/showall do ApiEcommerce):
//   { tipo_destino?, link?, link_ref_id?, link_ref_label? }
//
// tipo_destino define como montar a URL:
//   custom     → link (URL livre digitada no admin)
//   filtro     → /f/<link_ref_id>  (URL canônica do filtro rastreável,
//                resolvida server-side por NavigationController do
//                ApiEcommerce que registra evento de clique automaticamente —
//                por isso usa <a href> e força full request, NÃO router-link)
//   marca      → rota nomeada catalogoRota com query { marca: link_ref_id }
//   fornecedor → idem com query { fornecedor }
//   categoria  → idem com query { categoria }
//
// Compat: imagens legacy sem tipo_destino caem no caminho do 'custom',
// preservando o comportamento anterior (link como URL pronta).

function asString(v) {
  return typeof v === "string" ? v.trim() : "";
}

function hasRawLink(link) {
  const s = asString(link);
  return s !== "" && s !== "./";
}

function pickedTipo(image) {
  if (!image || typeof image !== "object") return null;
  const t = asString(image.tipo_destino);
  return t || null;
}

function refId(image) {
  if (!image) return null;
  const v = image.link_ref_id;
  if (v === undefined || v === null) return null;
  const s = String(v).trim();
  return s === "" ? null : s;
}

// Decide qual tag de elemento renderizar (a / router-link / div).
export function getComponentLinkTag(image) {
  const tipo = pickedTipo(image);
  const ref = refId(image);

  if (tipo === "filtro" && ref) return "a";
  if (
    (tipo === "marca" || tipo === "fornecedor" || tipo === "categoria") &&
    ref
  )
    return "router-link";

  // custom ou legacy (sem tipo_destino) → trata pelo link
  const link = image && image.link;
  if (hasRawLink(link)) return "a";
  return "div";
}

// Atributos a passar via v-bind no componente dinâmico.
export function getComponentLinkBind(image) {
  const tipo = pickedTipo(image);
  const ref = refId(image);

  if (tipo === "filtro" && ref) {
    // /f/<id> é resolvido por NavigationController::indexSearchFilter no
    // ApiEcommerce — registra clique via job ProcessFilterSearchLog. Precisa
    // ser <a href> (full request); router-link bypass do server quebra o
    // tracking.
    return { href: `/f/${encodeURIComponent(ref)}` };
  }

  if (tipo === "marca" && ref) {
    return { to: { name: "catalogoRota", query: { marca: ref } } };
  }
  if (tipo === "fornecedor" && ref) {
    return { to: { name: "catalogoRota", query: { fornecedor: ref } } };
  }
  if (tipo === "categoria" && ref) {
    return { to: { name: "catalogoRota", query: { categoria: ref } } };
  }

  // custom ou legacy
  const link = image && image.link;
  const s = asString(link);
  if (!hasRawLink(s)) return {};

  return { href: s };
}

// Conveniência: true se há clique definido.
export function hasComponentLink(image) {
  return getComponentLinkTag(image) !== "div";
}
